import { defineStore } from 'pinia';
import { FullUser, InitialUser } from './user-types';

export const useUserStore = defineStore({
  id: 'user',

  state: () => ({
    user: null as InitialUser | null,
    profileUser: null as FullUser | null,
    resetPasswordTokenValid: null as boolean | null,
  }),

  getters: {
    loggedIn(): boolean {
      return !!this.user;
    },
  },

  actions: {
    setUser(user: InitialUser) {
      this.user = user;
    },
    setProfileUser(user: FullUser) {
      this.profileUser = user;
    },
    logout() {
      this.user = null;
    },
    setResetPasswordTokenValid(value: boolean | null) {
      this.resetPasswordTokenValid = value;
    },
  },
});
